import { render } from "./CoursesDetailsView.vue?vue&type=template&id=515e140b&scoped=true&ts=true"
import script from "./CoursesDetailsView.vue?vue&type=script&lang=ts"
export * from "./CoursesDetailsView.vue?vue&type=script&lang=ts"

import "./CoursesDetailsView.vue?vue&type=style&index=0&id=515e140b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-515e140b"]])

export default __exports__